var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9975 10L8.5 3.81916L15.0025 10L17 8.09717L8.5 0L0 8.09717L1.9975 10Z",
    fill: "#332E3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiUpArrow);
export default __webpack_public_path__ + "static/media/HIUpArrow.c1f36b6bb5b59b1690dd554b2e74ed45.svg";
export { ForwardRef as ReactComponent };